import { TActionsWithoutState } from '../../Interfaces/TActionsWithoutState';
import { create } from './Actions/create';
import { get } from './Actions/get';

const actions = {
  create,
  get
};

export type IAdminRoundFormatAwardsActions = TActionsWithoutState<typeof actions>;

export default actions;
